module.exports = __webpack_public_path__ + "static/img/04_spw_plakatprasentation_304x204mm.c139c43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spoe/04_spw_plakatprasentation_304x204mm.jpg
// module id = 202
// module chunks = 1